<template lang="html">
  <div class="pussy-talk-container">
    <div class="pussy-talk-bg">
      <img src="../../assets/img/pussy-talk-bg.svg" alt="">
    </div>
    <div class="pussy-talk-hero">
      <h2>
        <svg id="pussy-talk-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.9 29.5"><title>Untitled-1</title><path d="M29.13,1.25H2.87a.82.82,0,0,0-.6,1.37L14.5,15.79V29.25a1.5,1.5,0,0,0,3,0V15.79L29.73,2.62A.82.82,0,0,0,29.13,1.25Z" transform="translate(-2.05 -1.25)" fill="#e364ae"/></svg>
        <span class="ml-3">PUSSY TALK</span>
      </h2>
      <h1>Vaginas are extraordinary, dynamic living systems.</h1>
      <div class="pussy-talk-text pb-5">
        <p>Complex ecological communities of microorganisms live within your vagina.
        These microorganisms and your vagina exist in symbiotic harmony — and while
        we won’t go into the science of it all, the bottom line is that a balanced flora plays
        a big role in keeping your vagina healthy and happy.</p>
        <p>With that in mind, we developed HappyG as a simple solution for monitoring your
        vagina’s health anytime, anyplace, in just a few minutes.</p>
        <p>Knowing that your vagina is in good health — and that you can address whatever
        issues arise — means you’ll feel safe, informed, and in control.</p>
        <p>And that from now on, every time you think about your vagina, the only thing that
        pops to mind is <span class="pink-text">pleasure.</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .pussy-talk-container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
    grid-gap: 1em;
  }
  .pussy-talk-bg {
    grid-column: 6/13;
    grid-row: 1/6;
    align-self: center;
    margin-top: -5rem;
  }
  .pussy-talk-hero {
    padding-top: 1em;
    grid-column: 2/12;
    grid-row:4/12;
    text-align: left;
    z-index: 3;
  }
  #pussy-talk-icon {
    width: 20px;
    height: auto;
    padding-bottom: 5px;
  }
  @media (min-width: 768px) {
    .pussy-talk-hero {
      grid-row:2/12;
    }

    .pussy-talk-hero h1 {
      font-size: 3.5rem;
    }
  }
  @media (min-width: 992px) {
    .pussy-talk-bg {
      grid-column: 8/12;
      grid-row: 1/6;
      align-self: center;
      margin-top: -5rem;
    }

    .pussy-talk-hero {
      grid-column: 2/10;
      grid-row:2/10;
    }

    .pussy-talk-hero h1 {
      font-size: 4rem;
    }
  }
  @media (min-width: 1200px) {
    .pussy-talk-bg {
      grid-column: 8/11;
      grid-row: 1/6;
      align-self: center;
      margin-top: -5rem;
    }

    .pussy-talk-hero {
      grid-column: 3/8;
      grid-row:2/10;
    }

    .pussy-talk-hero h1 {
      font-size: 5rem;
    }
   }
</style>
